import ProEvent from "../../../../src/events/2021/09/event-pro/proEvent";
import * as React from 'react';
export default {
  ProEvent,
  React
};